<template>
  <gg-card>
    <gg-card-header>
      Access phpMyAdmin
    </gg-card-header>
    <gg-card-text>
      <p>
        You can use phpMyAdmin to access and manage all of your databases, run queries and other database management commands directly.
      </p>

      <gg-btn primary @click="launch_phpmyadmin(hostingid, $route.query.user)">
        Launch phpMyAdmin
        <v-icon small class="pl-2">
          mdi-open-in-new
        </v-icon>
      </gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { launch_phpmyadmin } from 'Helpers/helpers'

export default {
  name: 'PhpMyAdminView',
  methods: {
    launch_phpmyadmin
  },
  computed: {
    hostingid () {
      return this.$route.params.hostingid
    },
  }
}
</script>

<style scoped>

</style>
